var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"col-12"},[_c('h3',{staticClass:"title primary--text"},[_vm._v("Notas:")]),_c('NoteForm',{attrs:{"fetchNotes":_vm.fetchNotes,"addNote":_vm.addNote,"updateNote":_vm.updateNote,"deleteNoteApi":_vm.deleteNote,"idKey":'claim_id'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }